import { nanoid } from 'nanoid/non-secure';

import { Operation, OperationType } from '../model/operation';
import { AliceApp } from '../model/skill';

interface CreateOperationParams {
    aliceApp: AliceApp;
    type: OperationType;
}

export const createOperation = ({ aliceApp, type }: CreateOperationParams): Operation => {
    return {
        comment: '',
        createdAt: new Date().toJSON(),
        itemId: aliceApp.id,
        itemName: aliceApp.name,
        type,
        id: nanoid(),
    };
};
